module.exports = __webpack_public_path__ + "images/6bb956456e3c11de158163d6cc2db4dc.svg";